var _style, _defs, _path, _path2, _path3, _path4, _path5;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgPvComodidade = function SvgPvComodidade(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Camada_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{clip-path:url(#SVGID_2_);}\r\n")), /*#__PURE__*/React.createElement("g", null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_1_",
    width: 512,
    height: 512
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_2_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    style: {
      overflow: "visible"
    }
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M316,126c5.5,0,10,4.5,10,10c0,5.5-4.5,10-10,10c-5.5,0-10-4.5-10-10C306,130.5,310.5,126,316,126"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M256,126c5.5,0,10,4.5,10,10c0,5.5-4.5,10-10,10c-5.5,0-10-4.5-10-10C246,130.5,250.5,126,256,126"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M196,126c5.5,0,10,4.5,10,10c0,5.5-4.5,10-10,10c-5.5,0-10-4.5-10-10C186,130.5,190.5,126,196,126"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M502,396h-35V136c0-5.5-4.5-10-10-10h-71V76c0-22.1-17.9-40-40-40H166c-22.1,0-40,17.9-40,40v50H55 c-5.5,0-10,4.5-10,10v260H10c-5.5,0-10,4.5-10,10c0,38.6,31.4,70,70,70h141c5.5,0,10-4.5,10-10c0-5.5-4.5-10-10-10H70 c-24.1,0-44.3-17.2-49-40h470c-4.6,22.8-24.8,40-49,40H301c-5.5,0-10,4.5-10,10c0,5.5,4.5,10,10,10h141c38.6,0,70-31.4,70-70 C512,400.5,507.5,396,502,396 M146,76c0-11,9-20,20-20h180c11,0,20,9,20,20v120c0,11-9,20-20,20h-60c-3.8,0-7.2,2.1-8.9,5.5 L256,263.6l-21.1-42.1c-1.7-3.4-5.2-5.5-8.9-5.5h-60c-11,0-20-9-20-20V76z M447,396H65V146h61v50c0,22.1,17.9,40,40,40h53.8 l27.2,54.5c1.7,3.4,5.2,5.5,8.9,5.5s7.2-2.1,8.9-5.5l27.2-54.5H346c22.1,0,40-17.9,40-40v-50h61V396z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M256,456c5.5,0,10,4.5,10,10c0,5.5-4.5,10-10,10c-5.5,0-10-4.5-10-10C246,460.5,250.5,456,256,456"
  }))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgPvComodidade, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/pv-comodidade.d25e041e.svg";
export { ForwardRef as ReactComponent };